import Rule from "../Rule";
import OrderActivity from "../../Crud/OrderActivity";

const insuranceSubTypeIdsRequiringE1028 = [
    211, // Superior Health MCD Replacement
    169, // Meridian Health MCD Replacement
];

export default class RuleE1028NotAllowedToEnableDSWOButton extends Rule {
    static message = "DSWO cannot be generated for this insurance when E1028 is present. Please use one of E1032, E1033, or E1034.";

    run() {
        // Read the active order activity record from chart-shaped rule input.
        const currentChartData = this.currentChartData?.orderActivity?.[this.orderActivityId];

        if (!currentChartData) {
            return this.pass();
        }

        // Business Support can bypass DSWO gating rules.
        // 96 = Business Support: Followup, 116 = Business Support
        if ([96, 116].includes(currentChartData.orderStatusReasonId)) {
            return this.pass();
        }

        // This rule applies to all other plans (not the E1028-required list).
        if (insuranceSubTypeIdsRequiringE1028.includes(currentChartData.insuranceSubTypeId)) {
            return this.pass();
        }

        // Normalize order HCPCS codes once for case-insensitive set membership checks.
        const products = OrderActivity.getProducts(currentChartData, this.currentChartData)
            .map(orderActivityProduct => this.currentChartData.product?.[orderActivityProduct.id])
            .filter(product => product?.deleted !== true);
        const hcpcsCodes = new Set(
            products.map(product => product.hcpcs?.toUpperCase()?.trim())
        );

        // Fail when E1028 appears on plans that require specific swingaway codes.
        if (hcpcsCodes.has("E1028")) {
            return this.fail();
        }

        return this.pass();
    }
}
